import React from 'react'
import ReactDOM from 'react-dom/client'
import Main from './App'
import { setupAppBackButton } from './utils/appBackButton'

// axios baseURL 由 api.ts 统一管理（/api）
// 不要在这里覆盖，否则会覆盖 api.ts 的设置

// 全局错误捕获：事件回调/异步错误 React ErrorBoundary 抓不到，兜底写 localStorage 便于定位"闪退"
const _captureErr = (type: string, msg: string, stack?: string) => {
  try {
    localStorage.setItem('aie_last_error', JSON.stringify({ type, msg, stack, at: new Date().toISOString() }))
  } catch {
    // 忽略
  }
}
window.addEventListener('error', (e) => _captureErr('error', e.message, e.error?.stack))
window.addEventListener('unhandledrejection', (e) => _captureErr('unhandledrejection', String(e.reason), e.reason?.stack))

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
)

// App 壳内安卓返回键：历史后退 / 首页双击退出（Web 端内部自动跳过）
setupAppBackButton()

// PWA:仅生产注册 Service Worker（dev 不注册，避免缓存开发资源）；
// Capacitor 壳内加载的是本地打包资源，同样跳过
if (import.meta.env.PROD && 'serviceWorker' in navigator && !(window as { Capacitor?: unknown }).Capacitor) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // SW 注册失败不影响正常使用（浏览器降级为普通网站）
    })
    // 旧版 SW 更新接管后刷新一次，确保用户拿到新版本；首次安装（无旧 controller）不刷
    let refreshing = false
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return
      if (!navigator.serviceWorker.controller) return
      refreshing = true
      window.location.reload()
    })
  })
}
